import type { ActivityEvent } from '@/shared/types/activityEvent';

export const DEDUP_WINDOW_MS = 60_000; // 60 seconds

/**
 * Collapse events that share the same actor + event_type + resource_name
 * within a short time window. Keeps the most recent event from each group.
 * Events are assumed to be sorted by timestamp descending.
 */
export function deduplicateEvents(events: ActivityEvent[]): ActivityEvent[] {
  const seen = new Map<string, number>(); // key -> timestamp ms of kept event
  return events.filter((event) => {
    const key = `${event.actor.user_id}|${event.event_type}|${event.subject.resource_name}`;
    const ts = event.timestamp.toDate().getTime();
    const lastSeen = seen.get(key);
    if (lastSeen !== undefined && Math.abs(lastSeen - ts) < DEDUP_WINDOW_MS) {
      return false; // duplicate within window
    }
    seen.set(key, ts);
    return true;
  });
}
